import { Component, Input, OnInit } from '@angular/core';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { AlertController, ModalController } from '@ionic/angular';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import RepositoryInterface from '../../../smoothr-web-app-core/directives/repository-directive';
import { OrderListAction } from '../../enums/OrderListAction';
import { AppComponent } from '../../app.component';
import { ModalInfoComponent } from '../modal-info/modal-info.component';
import { CheckoutModalComponent } from '../checkout-modal/checkout-modal.component';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleOption from '../../../smoothr-web-app-core/models/ArticleOption';
import { MenuPage } from '../../pages/menu/menu.page';
import Order from '../../../smoothr-web-app-core/models/Order';
import { PromoCodeType } from '../../../smoothr-web-app-core/models/PromoCodeType';
import { numberToCurrency } from '../../../smoothr-web-app-core/utils/utils';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { NoteArticleModalComponent } from '../note-article-modal/note-article-modal.component';
import { ShowRecomendationArticlesComponent } from '../show-recomendation-articles/show-recomendation-articles.component';
import { NavigationService } from 'src/app/services/navigation.service';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { Coupon } from 'src/smoothr-web-app-core/models/Coupon';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { InfoModalComponent } from '../info-modal/info-modal.component';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import { ValidationUtils } from 'src/smoothr-web-app-core/utils/validation-utils';

@Component({
	selector: 'app-order-content',
	templateUrl: './order-content.component.html',
	styleUrls: ['order-content.component.scss'],
})
export class OrderContentComponent extends RepositoryInterface implements OnInit {
	moment = moment;

	isValid = false;
	loading = false;

	ou = OrderUtils;
	pt = PreorderType;
	differenceToMvo: number;
	@Input()
	fromMenu = false;
	promoError: string;
	tip = 0;
	showDailog = false;
	numberToCurrency = numberToCurrency;
	userPoints: number = 0;
	public changeOrderBalance$ = new Subject<void>();
	constructor(
		private translate: TranslateService,
		protected repository: RepositoryService,
		private modalCtrl: ModalController,
		private snackbarCtrl: MatSnackBar,
		private navService: NavigationService,
		private alertCtrl: AlertController,
		private analytics: AnalyticsService
	) {
		super(repository);
		this.validate();
	}

	get hasArticles(): boolean {
		return (this.order?.orderedArticles?.length ?? 0) > 0;
	}

	ngOnInit() {
		super.ngOnInit();
		this.analytics.openOrderContent();
		this.changeOrderBalance$.pipe(debounceTime(1200)).subscribe(v => {
			console.log(v);
			this.repository.addPointsToArticle();
		});
	}

	onVenue() {
		super.onVenue();
		this.validate();
	}
	onCustomer(): void {
		super.onCustomer();
	}
	onOrder() {
		super.onOrder();
		if (this.order && this.order.orderedArticles && this.order.orderedArticles.length > 0) {
			this.analytics.orderHasProducts();
		}
		this.validate();
	}

	async onAction(index: number, event: OrderListAction) {
		switch (event) {
			case OrderListAction.add:
				if (this.order.orderedArticles[index]?.redeemWithPiggyPoints) {
					const sum = this.order.orderedArticles[index]?.redeemPointsWithPiggy;

					if ((this.customer.piggyPoints - this.customer.usedPiggyPoints ?? 0) - sum > 0) {
						this.order.orderedArticles[index].quantity += 1;
						this.order.orderedArticles[index].redeemQuantityWithPiggy =
							this.order.orderedArticles[index].article.piggyPointsNeeded * this.order.orderedArticles[index].quantity;
					} else {
						this.snackbarCtrl.open('You don`t have enought ASH points', null, {
							duration: 4000,
						});
					}
				} else {
					this.order.orderedArticles[index].quantity += 1;
				}
				break;
			case OrderListAction.delete:
				if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && this.order.promoCode.type === PromoCodeType.BOGO) {
					const bogoArticleIndex = this.order.orderedArticles.findIndex(ag => ag.isPromo);
					const bogoArticle = this.order.orderedArticles[bogoArticleIndex];
					const matchingBogoArticleIndices = this.order.orderedArticles
						.map((ag, agIndex) => {
							return ag.article._id === bogoArticle.article._id &&
								!ag.isPromo &&
								OrderUtils.bogoPrice(ag, this.order.type, this.order.preorder.type) ===
									OrderUtils.bogoPrice(bogoArticle, this.order.type, this.order.preorder.type)
								? agIndex
								: -1;
						})
						.filter(agIndex => agIndex !== -1);
					if (matchingBogoArticleIndices.find(bogoIndex => bogoIndex === index) !== undefined) {
						// article that should be removed is a possible parent of promoCode article
						if (matchingBogoArticleIndices.length === 1) {
							// only that article is possible parent of promoCode. If this article is removed the PromoCode and PromoArticle
							// should also be removed. Ask user.
							const bogoAlert = await this.alertCtrl.create({
								header: this.translate.instant('remove_bogo_alert.header'),
								message: this.translate.instant('remove_bogo_alert.message'),
								buttons: [
									{
										text: this.translate.instant('remove_bogo_alert.button_remove'),
										handler: () => {
											this.order.orderedArticles[bogoArticleIndex].isPromo = false;
											this.order.promoCode = null;
											this.order.orderedArticles.splice(index, 1);
											bogoAlert.dismiss();
										},
									},
									{
										text: this.translate.instant('remove_bogo_alert.button_keep'),
										handler: () => {
											bogoAlert.dismiss();
										},
									},
								],
							});
							await bogoAlert.present();
							await bogoAlert.onDidDismiss();
							break;
						}
					}
				}

				this.order.orderedArticles.splice(index, 1);

				break;
			case OrderListAction.note:
				this.noteArticle(index);
				break;
			case OrderListAction.edit:
				const modal = await this.modalCtrl.create({
					cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
					component: ModalInfoComponent,
					componentProps: {
						// copy article group
						articleGroup: JSON.parse(JSON.stringify(this.order.orderedArticles[index])),
						recommend: false,
					},
					showBackdrop: true,
					backdropDismiss: true,
				});
				await modal.present();
				const response = await modal.onDidDismiss();
				if (response.data && response.data.articleGroup) {
					const promoAgIndex = this.order.orderedArticles.findIndex(oa => oa.isPromo);
					if (
						OrderUtils.isBogoOrFreeArticlePromo(this.order) &&
						this.order.promoCode.type === PromoCodeType.BOGO &&
						this.order.orderedArticles[index].article._id === this.order.orderedArticles[promoAgIndex].article._id &&
						OrderUtils.bogoPrice(response.data.articleGroup, this.order.type, this.order.preorder.type) <
							OrderUtils.bogoPrice(this.order.orderedArticles[promoAgIndex], this.order.type, this.order.preorder.type)
					) {
						this.order.orderedArticles[promoAgIndex].isPromo = false;
						const newPromoAg = JSON.parse(JSON.stringify(response.data.articleGroup));
						newPromoAg.isPromo = true;
						this.order.orderedArticles.push(newPromoAg);
					}
					this.order.orderedArticles[index] = response.data.articleGroup;
					this.repository.order.next(this.order);
				}
				break;
			case OrderListAction.remove:
				if (this.order.orderedArticles[index].quantity > 1) {
					this.order.orderedArticles[index].quantity -= 1;
					if (this.order.orderedArticles[index]?.redeemQuantityWithPiggy) {
						this.order.orderedArticles[index].redeemQuantityWithPiggy =
							this.order.orderedArticles[index].article.piggyPointsNeeded * this.order.orderedArticles[index].quantity;
					}
				} else {
					await this.onAction(index, OrderListAction.delete);
					return;
				}
				break;
		}
		this.changeOrderBalance$.next();
		this.repository.order.next(this.order);
	}
	changeOrderBalance() {}
	async openSelectedProduct(item: Article) {
		item.defaults = [];
		const res = await ModalInfoComponent.show(this.modalCtrl, item, this.order.preorder?.type);
		if (res) {
			OrderUtils.addToOrder(this.order, res, this.analytics);
			this.repository.order.next(this.order);
		}
	}
	async openCheckoutModal() {
		if (!this.isValid || !this.venue) {
			return;
		}
		this.loading = true;
		const result = await CheckoutModalComponent.show(this.modalCtrl, this.order, this.tip);
		if (result.data === undefined) {
			this.loading = false;
			return;
		}
		this.order.orderAt = result.data.orderAt;
		this.order.preorder = result.data.preorder;
		this.tip = result.data.tip;
		this.repository.order.next(this.order);
		try {
			await this.repository.createOrderWithPayment(
				this.modalCtrl,
				this.translate,
				this.order,
				this.tip,
				loading => (this.loading = loading),
				this.snackbarCtrl,
				this.order.tableNumber !== 'preorder_table'
			);
			this.tip = 0;
		} catch (e) {
			console.log(JSON.parse(JSON.stringify(e)));
		}
	}

	validate() {
		if (!this.order || !this.venue) {
			this.isValid = false;
			return;
		}
		const result = this.validateOrder(this.venue, this.order);

		this.differenceToMvo = result.movDifference;
		this.isValid = result.valid;
		console.log(result);
	}

	validateOrder(venue: Venue, order: Order): { valid: boolean; movDifference: number } {
		const orderValue = OrderUtils.orderTotalPrice(order, false, true, true);

		let mov = order.preorder?.type === PreorderType.DELIVERY ? OrderUtils.findMov(venue, order, orderValue) : 0;

		let articlesValid = order.orderedArticles.length !== 0;
		if (OrderUtils.hasPromo(order)) {
			mov = Math.max(mov, +order.promoCode.mov);
		}
		for (const oa of order.orderedArticles) {
			if (!ValidationUtils.areGroupsValid(oa, oa.article.groups)) {
				articlesValid = false;
				break;
			}
		}
		console.log(orderValue, mov, articlesValid);
		return {
			valid: orderValue >= mov && articlesValid,
			movDifference: orderValue - mov,
		};
	}

	totalPrice(): string {
		return numberToCurrency(OrderUtils.orderTotalPrice(this.order, true, true, true) + this.tip, this.order.currency);
	}
	getAmountOfPointsAnonimus() {
		return Math.round(OrderUtils.orderTotalPrice(this.order, true, true, true) + this.tip);
	}

	replace(index: number, article: Article, options: ArticleOption[]) {
		this.order.orderedArticles[index].quantity = 1;
		this.order.orderedArticles[index].article = article;
		this.order.orderedArticles[index].groups = options;
	}

	onPromoApplied(order: Order) {
		this.promoError = null;
		this.repository.order.next(order);
		this.repository.addPointsToArticle();
	}

	onDeletePromo(order: Order) {
		this.promoError = null;
		this.repository.order.next(order);
		this.repository.addPointsToArticle();
	}

	async onPromoCodeError(error: string) {
		if (!error) {
			// error just resetting error no error happened
			return;
		}
		// Promo error

		// this.snackbarCtrl.open(error, null, {duration: 2000});
		await InfoModalComponent.show(this.modalCtrl, {
			info: error,
			title: null,
			mainButton: null,
			closeButton: this.translate.instant('add_points.close'),
		});
		this.repository.order.next(OrderUtils.removePromo(this.order));
		this.promoError = error;
	}

	backToMenu() {
		if (this.order?.orderedArticles?.length > 0) {
			this.navService.menu();
		} else {
			this.navService.menu();
		}
	}
	async noteArticle(index: number) {
		const modal = await this.modalCtrl.create({
			cssClass: 'short-info-modal auto-height',
			component: NoteArticleModalComponent,
			componentProps: {
				// copy article group
				articleGroup: JSON.parse(JSON.stringify(this.order.orderedArticles[index])),
				recommend: false,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const response = await modal.onDidDismiss();
		if (response?.data) {
			this.order.orderedArticles[index].note = response?.data;
		}
	}
	deleteCoupon(coupon: Coupon) {
		if (this.order.coupon.length > 0) {
			this.order.coupon = this.order.coupon.filter(it => it?._id !== coupon._id);
			this.order.orderedArticles = this.order.orderedArticles.filter(
				articleGroup => !(coupon?.value?.includes(articleGroup.article._id) && articleGroup.freeArticle && articleGroup.isPromo)
			);
			this.repository.order.next(this.order);
		}
	}
	async navigateTorLogin() {
		await this.navService.signIn();
	}
	async navigateTorSignUp() {
		await this.navService.signUp();
	}
	calculatePrice(coupon: Coupon) {
		return OrderUtils.calcDiscountOfCoupon(this.order, coupon);
	}
	checkDeliveryPrice(order: Order) {
		return OrderUtils.getDeliveryFees(order) ?? 0;
	}
	async changeOrderType() {
		const result = await InfoModalComponent.show(this.modalCtrl, {
			title: this.translate.instant('order_content.lose_order_title'),
			info: this.translate.instant('order_content.lose_order_info'),
			mainButton: this.translate.instant('account.delete_account.yes'),
			closeButton: this.translate.instant('account.delete_account.no'),
		});
		if (result) {
			this.navService.home();
		}
	}
}
